import { Stack, styled, Typography } from '@mui/material';

export const StyledStack = styled(Stack)(({ theme }) => ({
  flexFlow: 'column nowrap',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(12, 0, 8, 0),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(12, 0),
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(0, 0),
  },
}));

export const StyledTwoTitles = styled('div')(({ theme }) => ({
  display: 'grid',
  gridAutoFlow: 'column',
  gridAutoColumns: '1fr',
  gap: '5%',
  zIndex: '1',
  marginBottom: '10%',
  [theme.breakpoints.down('sm')]: {
    gridAutoFlow: 'row',
  },
}));

export const StyledFirstTitle = styled('div')(({ theme: { breakpoints } }) => ({
  fontWeight: '700',
  fontSize: '3vw',
  lineHeight: '100%',
  letterSpacing: '-0.02em',
  display: 'flex',
  justifyContent: 'center',
  background:
    'linear-gradient(180deg, #FFFFFF 0%, rgba(217, 217, 217, 0.8) 100%)',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  [breakpoints.down('sm')]: {
    fontSize: '7vw',
    textAlign: 'center',
  },
}));
export const StyledSecondTitle = styled('div')(
  ({ theme: { breakpoints } }) => ({
    fontSize: '1.2vw',
    color: '#ABB1B4',
    lineHeight: '150%',
    letterSpacing: '-0.02em',
    display: 'flex',
    alignSelf: 'flex-end',
    [breakpoints.down('sm')]: {
      fontSize: '4vw',
      textAlign: 'center',
    },
  })
);

export const StyledServices = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gridTemplateRows: '1fr 1fr 1fr',
  columnGap: '5%',
  rowGap: '20%',
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: 'none',
    gridTemplateRows: 'none',
    rowGap: '5%',
  },
}));

export const StyledServiceItem = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },
}));

export const StyledSeriviceIcon = styled('div')(({ theme }) => ({
  background:
    'radial-gradient(47.45% 48.31% at -0.77% 0%, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0) 100%), rgba(255, 255, 255, 0.03);',
  width: '96px',
  height: '96px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  marginRight: '20px',
  [theme.breakpoints.down('md')]: {
    marginRight: '0',
    marginTop: '10%',
  },
}));

export const StyledServiceTitle = styled(Typography)(({ theme }) => ({
  fontWeight: '700',
  fontSize: '1vw',
  lineHeight: '100%',
  letterSpacing: '-0.02em',
  marginBottom: '10px',
  background:
    'linear-gradient(180deg, #FFFFFF 0%, rgba(217, 217, 217, 0.8) 100%)',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  [theme.breakpoints.down('sm')]: {
    fontSize: '6vw',
    marginTop: '10%',
  },
}));

export const StyledServiceDescription = styled(Typography)(() => ({
  color: '#ABB1B4',
  lineHeight: '150%',
  letterSpacing: '-0.01em',
}));

export const StyledSteps = styled('div')(({ theme }) => ({
  border: '1px solid rgba(255, 255, 255, 0.1)',
  borderRadius: '24px',
  display: 'grid',
  gridTemplateColumns: '1fr 1fr 1fr',
  columnGap: '0%',
  marginTop: '30%',
  paddingLeft: '3%',
  paddingRight: '3%',
  ['& > div:nth-last-of-type(-n+2)']: {
    borderLeft: '1px solid rgba(255, 255, 255, 0.1)',
    paddingLeft: '12%',
    paddingRight: '12%',
  },

  [theme.breakpoints.down('sm')]: {
    paddingLeft: '5%',
    paddingRight: '5%',
    ['& > div:nth-last-of-type(-n+2)']: {
      borderLeft: 'none',
      paddingLeft: '0%',
      paddingRight: '0%',
    },
    gridTemplateColumns: 'none',
  },
}));

export const StyledStep = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  paddingTop: '12%',
  paddingBottom: '12%',
}));

export const StyledStepTitle = styled('div')(({ theme }) => ({
  fontWeight: '700',
  fontSize: '1.2vw',
  lineHeight: '100%',
  letterSpacing: '-0.02em',
  background:
    'linear-gradient(180deg, #FFFFFF 0%, rgba(217, 217, 217, 0.8) 100%)',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  marginTop: '20%',
  marginBottom: '5%',
  [theme.breakpoints.down('sm')]: {
    fontSize: '6.5vw',
  },
}));
